import { render, staticRenderFns } from "./item_actions.vue?vue&type=template&id=1a180463&scoped=true&"
import script from "./item_actions.vue?vue&type=script&lang=js&"
export * from "./item_actions.vue?vue&type=script&lang=js&"
import style0 from "./item_actions.vue?vue&type=style&index=0&id=1a180463&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a180463",
  null
  
)

export default component.exports